import { createSelectorCreator } from "reselect";
import { memoize, uniq, get, titleCase } from "sites-common/utils/lodash";

const hashFn = (...args) =>
  args.reduce((acc, val) => `${acc}-${JSON.stringify(val)}`, "");
const customSelectorCreator = createSelectorCreator(memoize, hashFn);

// const selector = customSelectorCreator(
//   state => state.a,
//   (a, b) => {
//     return a + b
//   }
// )

export const commonSelectors = (collection) => ({
  raw: (state) => state.firestore.data[collection],
  ordered: (state) => state.firestore.ordered[collection],
  id: (state, docId) =>
    collection in state.firestore.data && !!docId
      ? state.firestore.data[collection][docId]
      : undefined,

  listGivenKV: (key) => (state, value) =>
    !!key && collection in state.firestore.ordered
      ? state.firestore.ordered[collection].filter((b) => b[key] === value)
      : [],

  valuesGivenKey:
    (key, transforms = {}) =>
    (state) =>
      collection in state.firestore.ordered
        ? uniq(state.firestore.ordered[collection].map((b) => b[key]))
            .sort()
            .map((x) => ({
              key: x,
              text:
                "transform" in transforms
                  ? transforms.transform(x)
                  : titleCase(x),
            }))
        : [{ key: "", text: "Loading ... " }],

  getValuesOnlyGivenKey: (state, key) =>
    collection in state.firestore.ordered
      ? state.firestore.ordered[collection].map((b) => get(b, key))
      : [],

  valuesGivenFunction: (fn) => (state) =>
    collection in state.firestore.ordered &&
    !!state.firestore.ordered[collection]
      ? state.firestore.ordered[collection].map(fn)
      : [],
});

export const commonSelectorswithPreprocess = (collection, preprocess) => {
  const rawSelector = customSelectorCreator(
    (state) => get(state.firestore.data, collection),
    (raw) => {
      const ret = {};
      if (raw) {
        Object.entries(raw).forEach(([key, val]) => {
          ret[key] = preprocess(val);
        });
      }
      return ret;
    }
  );
  const orderedSelector = customSelectorCreator(
    (state) => get(state.firestore.ordered, collection, []),
    (ordered) => ordered.map(preprocess)
  );
  const idSelector = (state, docId) =>
    !docId ? undefined : get(rawSelector(state), docId);

  return {
    raw: rawSelector,
    ordered: orderedSelector,
    id: idSelector,

    listGivenKV: (key) => (state, value) =>
      key ? orderedSelector(state).filter((b) => b[key] === value) : [],

    valuesGivenKey: (key, transforms = {}) =>
      customSelectorCreator(orderedSelector, (ordered) =>
        ordered
          ? uniq(ordered.map((b) => b[key]))
              .sort()
              .map((x) => ({
                key: x,
                text:
                  "transform" in transforms
                    ? transforms.transform(x)
                    : titleCase(x),
              }))
          : [{ key: "", text: "Loading ... " }]
      ),

    getValuesOnlyGivenKey: (state, key) =>
      orderedSelector(state).map((b) => get(b, key)),

    valuesGivenFunction: (fn) => (state) => orderedSelector(state).map(fn),
  };
};
